import { useEffect, useState } from 'react'
import { BasicPage } from '@/components/layout/BasicPage'
import { FEED_CDN, REST_API } from '@/utilities/envVariables'
import { AevocamPlayer } from '@/lib/aevocam-player/AevocamPlayer'
import {
  AevocamPlayerProvider,
  type AevocamFeedSummary,
} from '@/lib/aevocam-player/useAevocamPlayer'
import { useParams } from 'react-router-dom'
import { useApi } from '@/hooks/useApi'
import { Button } from '@/components/action/Button'
import { routes } from '@/utilities/routes'

export function FeedViewPage() {

  const { tenant: tenantId, feed: feedId } = useParams()
  const api = useApi()
  const [feedSummary, setFeedSummary] = useState<AevocamFeedSummary | null>(null)

  useEffect(() => {
    setFeedSummary(null)
  }, [tenantId, feedId])

  const pageTitle = feedSummary
    ? `Camera feed: ${feedSummary.feed.name}`
    : 'Camera feed'

  return (
    <BasicPage
      title={pageTitle}
      className='FeedViewPage'
      toolbarButtons={<>
        <Button
          label='Feeds'
          icon='chevronLeft'
          href={routes.home(tenantId!)}
        />
        <Button
          label='Edit'
          href={routes.feedEdit(tenantId!, feedId!)}
        />
      </>}
    >
      <div className='PageContent Cutout Wrapped Height100'>

        {api.status.session?.sessionId && (
          <AevocamPlayerProvider
            startAtLatest
            sessionKey={api.status.session?.sessionId}
            cdnUrl={FEED_CDN}
            apiUrl={REST_API}
            tenantId={tenantId!}
            feedId={feedId!}
            keyboardHandlersGlobal
            onFeedSummary={setFeedSummary}
          >
            <AevocamPlayer />
          </AevocamPlayerProvider>
        )}

      </div>
    </BasicPage>
  )
}